export default function PrivacyPoliciesIcon({ className="", onClick=null }) {
  return (
    <>
      <svg
        className={className}
        onClick={onClick}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 500"
      >
        <path d="M335,194.31v-64.06c0-19.02-8.55-36.3-24.09-48.67-15.47-12.32-36.53-18.83-60.91-18.83-25.58,0-47.08,6.55-62.18,18.95-14.71,12.08-22.82,29.32-22.82,48.55v64.06h-42.5c-8.28,0-15,6.72-15,15v211.5c0,8.28,6.72,15,15,15h255c8.28,0,15-6.72,15-15v-211.5c0-8.28-6.72-15-15-15h-42.5ZM190,130.25c0-26.21,22.99-42.5,60-42.5s60,17.48,60,42.5v64.06h-120v-64.06ZM367.5,410.81h-235v-191.5h235v191.5Z"/>
        <path d="M237.5,339.47v32.97c0,3.87,3.13,7,7,7h11c3.87,0,7-3.13,7-7v-32.97c20.61-5.76,35.49-25.38,33.88-48.13s-19.99-41.3-42.8-43.01c-27.25-2.05-50.08,19.54-50.08,46.36,0,21.31,14.41,39.3,34,44.78ZM250,273.19c11.85,0,21.5,9.64,21.5,21.5s-9.65,21.5-21.5,21.5-21.5-9.64-21.5-21.5,9.65-21.5,21.5-21.5Z"/>
      </svg>
    </>
  );
}